<template>
  <div class="invalid-feedback" v-show="message" >
    <span><i class="fa fa-exclamation-circle" style="margin-top: 3px;margin-right: 4px;"></i>{{message}}</span>
  </div>
</template>

<script>
export default {
  name: 'FieldError',
  props: ['message'],
};
</script>

<style scoped>
.invalid-feedback{
  display: block;
  white-space: pre-wrap!important;
  text-align: left!important;
  font-size: 75%!important;
}
</style>
